import { Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled } from "@mui/material";

const GreenConnector = styled(StepConnector)(({theme}) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 15,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#46bda7',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#46bda7',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
    
    height: 3,
  },
}))

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 35,
  height: 35,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundColor: '#46bda7',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundColor: '#46bda7',
  }),
  fontSize: "16px",
  fontWeight: "bolder"
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    2: 2,
    3: 3,
    1: 1,
  };

  return (
    <>
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    </>
  );
}

const AddProjectStepper = ({step = 0}) => {
  return(
    <Stepper activeStep={step} alternativeLabel connector={<GreenConnector/>}>
      <Step>
        <StepLabel StepIconComponent={ColorlibStepIcon}></StepLabel>
      </Step>
      <Step>
        <StepLabel  StepIconComponent={ColorlibStepIcon}></StepLabel>
      </Step>
      <Step>
        <StepLabel StepIconComponent={ColorlibStepIcon}></StepLabel>
      </Step>
    </Stepper>
  )
}

export default AddProjectStepper